import { FormBase } from 'core/components';

export default class PasswordRecoveryForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'email',
                    label: 'PASSWORD_RECOVERY.EMAIL_LABEL',
                    placeholder: 'PASSWORD_RECOVERY.EMAIL_PLACEHOLDER',
                    rules: 'required'
                },
                {
                    name: 'recaptcha',
                    rules: 'required'
                }
            ],
        };
    }
}